import SeoPageLayout from "@/components/SeoPageLayout";

const WystepKabaretowyZielonaGora = () => (
  <SeoPageLayout title="Występ kabaretowy Zielona Góra - humor w stolicy wina">
    <p>
      Zielona Góra, znana jako polska stolica wina, to miasto z wyjątkowym klimatem i tradycjami. Występ kabaretowy w Zielonej Górze to świetna atrakcja na wydarzenia firmowe organizowane w tym dynamicznie rozwijającym się mieście.
    </p>

    <h2 className="text-2xl font-bold text-foreground mt-10">Kabaret na eventy firmowe w Zielonej Górze</h2>
    <p>
      Realizujemy występy kabaretowe w Zielonej Górze i całym województwie lubuskim. Występujemy w hotelach, centrach konferencyjnych, winiarniach i restauracjach. Program dostosowujemy do charakteru wydarzenia i oczekiwań organizatora.
    </p>

    <h2 className="text-2xl font-bold text-foreground mt-10">Gdzie występujemy w Zielonej Górze?</h2>
    <ul className="list-disc pl-6 space-y-2">
      <li>Hotele w centrum - profesjonalne eventy firmowe</li>
      <li>Winiarnie i piwnice win - klimatyczne spotkania tematyczne</li>
      <li>Centra konferencyjne - konferencje i szkolenia z humorem</li>
      <li>Obiekty w Lubuskim - integracje i wyjazdy firmowe</li>
    </ul>

    <h2 className="text-2xl font-bold text-foreground mt-10">Kabaret w klimacie Winobrania</h2>
    <p>
      Zielona Góra to miasto, które potrafi się bawić. Nasze występy kabaretowe nawiązują do lokalnych tradycji i specyfiki regionu, tworząc wyjątkową atmosferę, która łączy humor z duchem lubuskiej gościnności.
    </p>
  </SeoPageLayout>
);

export default WystepKabaretowyZielonaGora;
